let data_event_id = sessionStorage.getItem("data_event_id") || "10016";

document.addEventListener("DOMContentLoaded", () => {



  if (!customElements.get("xmas-2025-swiper-card")) {
    class CommonProductShowcase extends HTMLElement {
      constructor() {
        super();
        
       
        // DOM 引用
        this.productSelector = $(this).find(".xmas-swiper-card-selector")[0];
        this.descriptionDOM = $(this).find(".xmas-swiper-card-descriptions")[0];
        this.imageDom = $(this).find(".xmas-swiper-card-image img")[0];
       
        this.variantsDom = $(this).find(".xmas-swiper-card-variants")[0];
        this.reviewDom = $(this).find(".product_reviews")[0];
        this.priceDom = $(this).find(".product-price-box")[0];
        this.checkbox = $(this).find(".checkbox svg")[0];
        this.productUrlDom = $(this).find(".xmas-swiper-product-url")[0];
        this.popup = $(this).find("pc-selector-popup")[0];
        this.idInput = $(this).find(".variant-id-input")[0];
        this.homeIdInput = $(this).find(".home_product_id")[0];
        this.titleInput = $(this).find(".home_product_title")[0];
        this.categoryInput = $(this).find(".home_product_category")[0];
        this.selected = false;
       
        
      }

      connectedCallback() {
        
        // 初始化数据
        const jsonId = this.dataset.productsId;
        
        const script = document.getElementById(jsonId);
       
  if (!script) return;

   // this.data = JSON.parse(script.textContent);
        // 2. 提取标签内的文本内容（核心：取 textContent/innerText，而非元素本身）
const jsonString = script ? script.textContent.trim() : '';

// 3. 解析成数组（带异常处理）
 this.data = []
try {
  if (jsonString) {
    this.data = JSON.parse(jsonString);
    console.log('解析成功：', this.data); // 得到你需要的数组
  }
} catch (err) {
  console.error('解析失败：', err.message);
}


      
       
     

        // 默认选中
        // this.selectedProductHandle = JSON.parse(this.data)[0].handle;
  
        // this.selectedVariantId = JSON.parse(this.data)[0].variants[0].id;
         this.selectedProductHandle = '';
  
        this.selectedVariantId = '';
        this.initSelectProductCommon();
        this.initSelectProduct();
        this.initVariants();
        this.initChecked();
        this.updateData();
      }

      updateData(productHandle, variantId) {
        const product = productHandle ? JSON.parse(this.data).find((i) => i.handle === productHandle) : JSON.parse(this.data)[0];

        if (!product) return;

        this.selectedProductHandle = product.handle;
        this.selectedVariantId = variantId || product.variants[0].id;

        // 更新选择器 UI
        $(this.productSelector).find(".xmas-swiper-card-selector-text").text(product.title);

        $(this.productSelector)
          .find(".xmas-swiper-card-selector-option")
          .each((_, e) => {
            $(e).toggleClass("selected", e.dataset.productHandle === this.selectedProductHandle);
          });

        // 更新变体 UI
        $(this.variantsDom)
          .find(".xmas-swiper-card-variant-option")
          .each((_, e) => {
            $(e).toggleClass("selected", e.dataset.variantId === this.selectedVariantId);
          });

        // 更新描述
        if (product.description) {
          $(this.descriptionDOM).html(`<li class='xmas-swiper-card-description'>${product.description}</li>`);
        }

        if (this.idInput) {
          this.idInput.value = this.selectedVariantId;
        }

        if (this.homeIdInput) {
          this.homeIdInput.value = product.id;
        }
        if (this.titleInput) {
          this.titleInput.value = product.fullTitle||product.title;
        }
        if (this.categoryInput) {
          this.categoryInput.value = product.type;
        }

        // 更新评论
        $(this.reviewDom).html(product.review);

        // 更新图片
        if (this.imageDom) {
          this.imageDom.src = product.imageUrl;
          this.imageDom.alt = product.imageAlt;
        }

        if (this.productUrlDom) {
          this.productUrlDom.href = product.productUrl;
        }

        // 更新价格
        const variant = product.variants.find((v) => v.id === this.selectedVariantId);
        if (this.priceDom && variant) {
          $(this.priceDom).find(".on-sale").text(theme.Currency.formatMoney(variant.price, theme.strings.moneyFormat));
          this.price = variant.price;
          if (variant.compare_at_price) {
            $(this.priceDom)
              .find(".compare-at")
              .text(theme.Currency.formatMoney(variant.compare_at_price, theme.strings.moneyFormat));
            this.compare_at_price = variant.compare_at_price;
          } else {
            this.compare_at_price = variant.price;
          }
        }

        updateAllPrice();
      }

      initSelectProduct() {
        if (!this.productSelector || !this.popup) return;

        const $selector = $(this.productSelector);
        const $text = $selector.find(".xmas-swiper-card-selector-text");

        // 打开 popup
        $text.on("click", (e) => {
          e.stopPropagation();

          this.popup.open({
            data: this.data,
            selectedValue: this.selectedProductHandle,
            anchorEl: this.productSelector,
          });
        });

        // 监听 popup confirm
        this.addEventListener("confirm", (e) => {
          const handle = e.detail.value;
          this.initVariants(handle);
          this.updateData(handle);
        });
      }

      initVariants(productHandle) {
     
        if (!this.variantsDom) return;

        const $variants = $(this.variantsDom);
        $variants.empty();

        const product = productHandle ? JSON.parse(this.data).find((i) => i.handle === productHandle) : JSON.parse(this.data)[0];
        if (!product?.variants?.length || product.variants.length <= 1) return;

        product.variants.forEach((v) => {
          const $item = $(
            `<div class="xmas-swiper-card-variant-option" data-variant-id="${v.id}" style="background: ${v.swatch_color};"></div>`
          );
          $item.on("click", (e) => {
            e.stopPropagation();
            this.updateData(product.handle, v.id);
          });
          $variants.append($item);
        });
      }

      initChecked() {
     
        const $checked = $(this.checkbox);
        if ($checked[0]) {
          $checked.click((e) => {
            $checked.toggleClass("selected");
            this.selected = !this.selected;
            this.updateData(this.selectedProductHandle, this.selectedVariantId);
          });
        }
      }

      initSelectProductCommon() {
        const parent = this.closest(".products-box");
        if (parent) {
          parent.addEventListener("scroll", () => {
            $(document.body)
              .find("pc-selector-popup ")
              .each((index, el) => {
                el.close();
              });
            if (this.mobileSelector) {
              this.mobileSelector.close();
            }
          });
        }
        const swiperEl = this.productSelector?.closest(".swiper");

        if (!swiperEl) return;

        if (!swiperEl._optionsCloseBound) {
          swiperEl._optionsCloseBound = true;

          const waitSwiper = setInterval(() => {
            const instance = swiperEl.swiper;

            if (instance) {
              clearInterval(waitSwiper);

              // slide 切换时强制关闭 PC/Mobile 弹窗
              instance.on("slideChange", () => {
                $(document.body)
                  .find("pc-selector-popup ")
                  .each((index, el) => {
                    el.close();
                  });
                if (this.mobileSelector) {
                  this.mobileSelector.close();
                }
              });
            }
          }, 50);
        }
      }
    }

    customElements.define("xmas-2025-swiper-card", CommonProductShowcase);
  }
 
  function updateAllPrice() {
    let totalSalePrice = 0;
    let totalComparePrice = 0;
    let selectedCount = 0;
    const variants = [];
    const variantsIds = [];
    $(".xmas-2025-swiper-2 .xmas-swiper-card").each((index, e) => {
      if (e.selected) {
        totalSalePrice = totalSalePrice + Number(e.price);
        totalComparePrice = totalComparePrice + Number(e.compare_at_price);
        selectedCount = selectedCount + 1;
        variants.push({
          variantId: e.selectedVariantId,
          quantity: 1,
        });
        variantsIds.push(e.selectedVariantId);
        console.log(">>>>>", e.selectedVariantId, e.price, e.compare_at_price);
      }
    });
    
    let discountMultiplier = 1;

    // if (selectedCount >= 3) {
    //   discountMultiplier = 0.8; // 3件及以上打7折
    // } else if (selectedCount >= 2) {
    //   discountMultiplier = 0.85; // 2件打8折
    // }


        if (selectedCount >= 3) {
      discountMultiplier = 0.88; // 3件及以上折扣12%
    } else if (selectedCount >= 2) {
      discountMultiplier = 0.92; // 2件折扣8%
    }


    totalSalePrice = Math.round(totalSalePrice * discountMultiplier);

    const priceContainer = $(".xmas-2025-swiper-2 .change-showcase-container .product-price-box")[0];
    if (priceContainer) {
      const salePriceEl = $(priceContainer).find(".on-sale");
      const comparePriceEl = $(priceContainer).find(".compare-at");

      if (salePriceEl[0]) {
        // salePriceEl.setAttribute("content", totalSalePrice);
        salePriceEl.text(window.theme.Currency.formatMoney(totalSalePrice, window.theme.strings.moneyFormat));
      }

      if (comparePriceEl[0]) {
        // comparePriceEl.setAttribute("content", totalComparePrice);
        comparePriceEl.text(
          totalSalePrice !== totalComparePrice
            ? window.theme.Currency.formatMoney(totalComparePrice, window.theme.strings.moneyFormat)
            : ""
        );
      }
    }
    $(".xmas-2025-swiper-2 .change-showcase-container multi-add-cart-button").attr(
      "data-products",
      JSON.stringify(variants)
    );
     $(".xmas-2025-swiper-2 .change-showcase-container buy-now-button").attr(
      "data-variant-id",
        variantsIds.join(',')
    );
  }

  function handleImageMarksTrigger(e) {
    $(arguments[0].currentTarget).toggleClass("show-button");
  }
  $(".xmas-2025-swiper-2 .image-box .image-marks .image-mark")
    .click(handleImageMarksTrigger)
    .hover(handleImageMarksTrigger);

  $("#upCart").on("click", ".upcart-header-close-button, .upcart-backdrop", function (e) {
    if (window.timber?.RightDrawer?.drawerIsOpen) {
      window.timber.RightDrawer.drawerIsOpen = false;
    }
  }); 
 
});

document.addEventListener("DOMContentLoaded", () => {
   
  class PcSelectorPopup extends HTMLElement {
    constructor() {
      super();

      this.data = [];
      this.selectedValue = null;
      this.anchorEl = null;

      this.style.display = "none";

      // portal
      this.portal = document.createElement("div");
      this.portal.className = this.getAttribute("portal-class");
      this.portal.style.position = "absolute";
      this.portal.style.zIndex = "24";
      this.portal.style.display = "none";

      document.body.appendChild(this.portal);

      this.onDocClick = this.onDocClick.bind(this);

      this.trackedProducts = new Set();
    }

    open({ data, selectedValue, anchorEl }) {
      
      this.data = data;
      this.selectedValue = selectedValue;
      this.anchorEl = anchorEl;

      $("body").css("overflow-x", "hidden");

      this.render();
      this.position();
      this.portal.style.display = "block";

      document.addEventListener("click", this.onDocClick);
      this.isShow = true
    }

    close() {
      this.portal.style.display = "none";
      $("body").css("overflow-x", "");
      document.removeEventListener("click", this.onDocClick);
      this.isShow = false
    }

    render() {
      this.portal.innerHTML = "";

      JSON.parse(this.data).forEach((product) => {
        const isSelected = product.handle === this.selectedValue;
        const item = document.createElement("div");

        item.className = `xmas-swiper-card-selector-option${
          isSelected ? " selected" : ""
        }`;
        item.dataset.value = product.handle;
        item.textContent = product.title;

        item.addEventListener("click", (e) => {
          e.stopPropagation();
          this.confirm(product.handle);

          // === 埋点逻辑 ===
          if (this.trackedProducts.has(product.handle)) return; // 已埋点就跳过

          let scrollTop = window.scrollY || document.documentElement.scrollTop;
          let windowHeight =
            window.innerHeight || document.documentElement.clientHeight;
          let docHeight = document.documentElement.scrollHeight;

          let item_list_name =
            scrollTop + windowHeight / 2 < docHeight / 2
              ? "Christmas Gift Sets for Every Corner of Home"
              : "Get 1 Year of Accessories with Your Device";

          window.dataLayer.push({ ecommerce: null });

          window.dataLayer.push({
            event: "view_item_list",
            ecommerce: {
              item_list_id: `${data_event_id}`,
              item_list_name: item_list_name,
              items: [
                {
                  item_id: product.id,
                  item_name: product.fullTitle||product.title,
                  item_category: product.type,
                  item_brand: "dreame",
                  price: product.price ? product.price / 100 : 0,
                  index: 0,
                  quantity: 1,
                },
              ],
            },
          });

          this.trackedProducts.add(product.handle); // 标记已埋点
        });

        this.portal.appendChild(item);
      });

      // 阻止点 options 自身冒泡
      this.portal.addEventListener("click", (e) => e.stopPropagation());
    }

    position() {
      if (!this.anchorEl) return;

      const rect = this.anchorEl.getBoundingClientRect();

      this.portal.style.top = rect.bottom + window.scrollY + "px";
      this.portal.style.left = rect.left + window.scrollX + "px";
      this.portal.style.width = rect.width + "px";
    }

    confirm(value) {
      this.dispatchEvent(
        new CustomEvent("confirm", {
          detail: { value },
          bubbles: true,
          composed: true,
        })
      );
      this.close();
    }

    onDocClick() {
      this.close();
    }

    disconnectedCallback() {
      this.close();
      if (this.portal.parentNode) {
        this.portal.parentNode.removeChild(this.portal);
      }
    }
  }

  customElements.define("pc-selector-popup", PcSelectorPopup);
});
